const tokenOrigins = {
  CLARO_VIP_SMS_INCENTIVE: "claroVipSMSIncentive",
};

export default tokenOrigins;
